/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WorkTypeGroupResponseDto { 
    /**
     * Group identifier
     */
    id: string;
    /**
     * Group name
     */
    name: string;
    /**
     * URL-friendly slug
     */
    slug: string;
    /**
     * Group description
     */
    description?: string;
    /**
     * Group status
     */
    status: WorkTypeGroupResponseDto.StatusEnum;
    /**
     * Additional metadata associated with the group
     */
    metadata?: any;
}
export namespace WorkTypeGroupResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


